import { createContext, useContext } from "react";

/**
 * The listing refinement (serialised query string) surrounding this subtree, or
 * `""` outside a listing grid (SFCC-11958).
 *
 * A context rather than a `useSearchParams()` read inside the carousel hook:
 * `ProductCarousel` / `ProductRecommendations` are globally registered Builder
 * blocks, so an author can place a category carousel on any page — including a
 * PDP, whose URL carries variation attributes. `color` and `count` are BOTH
 * configured CIO facets (`FACET_MAPPING`), so a URL-wide read would silently
 * filter a PDP carousel by the shopper's selected variant. Scoping to the grid
 * keeps the inheritance to the one surface where the carousel really sits
 * inside a filtered result set.
 *
 * Contract for future consumers: this is only provided inside a listing grid.
 */
export const PlpRefinementContext = createContext<string>("");

export function usePlpRefinements(): string {
  return useContext(PlpRefinementContext);
}
